var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.034 23.992v.001l-.006.007.006-.008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.917 9.044a4.084 4.084 0 0 0 4.078 4.078 4.084 4.084 0 0 0 4.078-4.078 4.084 4.084 0 0 0-4.078-4.078 4.084 4.084 0 0 0-4.078 4.078Zm1.547-.007a2.536 2.536 0 0 1 2.531-2.531 2.536 2.536 0 0 1 2.531 2.531 2.536 2.536 0 0 1-2.53 2.531 2.536 2.536 0 0 1-2.532-2.53Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.034 23.992 7.211-9.542c1.15-1.527 1.791-3.298 1.844-5.122v-.284a8.98 8.98 0 0 0-2.723-6.47A8.99 8.99 0 0 0 11.83.003C7.045.108 3.172 3.942 3 8.72v.264c-.013 1.924.648 3.867 1.85 5.466l7.184 9.542Zm-.158-22.45h.185a7.45 7.45 0 0 1 5.241 2.135 7.44 7.44 0 0 1 2.26 5.367v.231c-.046 1.507-.575 2.974-1.533 4.236l-5.981 7.912L6.1 13.517c-1.005-1.335-1.553-2.94-1.54-4.527v-.218a7.499 7.499 0 0 1 7.316-7.23Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Location.5144b04bc0d3b93f32a1b9e55dbed14c.svg";